import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const InsurancePlansModal = ({
  open,
  onClose,
  onSave,
  preSelected = []
}) => {

  // 🔥 hardcoded here ONLY
  const plans = [
    "VISIT",
    "Labs",
    "Injections",
    "EKG",
    "ULTRASOUND",
    "SLEEP STUDY",
    "ECHO",
    "RPM"
  ];

  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) {
      setSelected(preSelected || []);
    }
  }, [open, preSelected]);

  if (!open) return null;

  const togglePlan = (plan) => {
    if (selected.includes(plan)) {
      setSelected(selected.filter((p) => p !== plan));
    } else {
      setSelected([...selected, plan]);
    }
  };

  const handleSave = () => {
    onSave(selected);   // send selected or []
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg w-[320px] p-4 relative">

        {/* X icon */}
        <div className="absolute right-3 top-3 cursor-pointer">
          <CloseIcon onClick={onClose} />
        </div>

        <h3 className="text-lg font-semibold mb-3">
          Insurance Covered Plans
        </h3>

        <div className="flex flex-col gap-2 max-h-[300px] overflow-auto">
          {plans.map((plan) => (
            <label key={plan} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selected.includes(plan)}
                onChange={() => togglePlan(plan)}
              />
              <span>{plan}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-end mt-4 gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 rounded bg-gray-200"
          >
            Cancel
          </button>

          <button
            onClick={handleSave}
            className="px-4 py-1 rounded bg-black text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsurancePlansModal;
